module.exports = __webpack_public_path__ + "img/henkel-tesistan.2bcf4f86.jpg";